import IconComponent from 'app_components/commons/icons';
import React from 'react';
import { MdModeEdit, MdSelectAll } from 'react-icons/md';
import { FiSettings } from 'react-icons/fi';
import { BsQuestionSquareFill, BsTools } from 'react-icons/bs';
import { IColorsTheme } from 'app_types/colors'
import { IConfigQuestion, IPossibleConfigQuestion, IQuestionMetadata, IQuestionTag2 } from 'app_types/editor/questionTypes';

export type TypeTabsEditor =
    'edit' |
    'advanced' |
    'general' |
    'new' |
    'tools' |
    'questions'

export type TypeFieldsTabsEditor =
    'title' |
    'description' |
    'icon' |
    'date' |
    'datetime' |
    'color' |
    'background' |
    'active' |
    'alliance' |
    'program' |
    'cycle' |
    'duration' |
    'level' |
    'save_progress' |
    'max_attemps' |
    'availability_range' |
    'show_results' |
    'continue_exercise' |
    'order_of_questions' |
    'time_limit' |
    'generates_statistics' |
    'complementary_resources_module' |
    'comments_module' |
    'like_module' |
    'help_module' |
    'save_module' |
    'share_module' |
    'related_lessons_module' |
    'game' |
    'learning_way_module' |
    'lessons_module' |
    'exercise_module' |
    'tutoring_module' |
    'homework_module' |
    'next_watching_module' |
    'channels_module' |
    'learning_path_module' |
    'my_book_module' |
    'game_statistics_module' |
    'tutoring_module' |
    'statistics_card_iga_module' |
    'statistics_card_lessons_completed_module' |
    'statistics_card_time_module' |
    'statistics_card_progress_module' |
    'exercise_ended' |
    'number_questions_section' |
    'value_component' |
    'components_related' |
    'skip_interaction' |
    'virtual_tutoring_external_link' |
    'virtual_tutoring_access_password' |
    'virtual_tutoring_record_link' |
    'course_modes' |
    'is_characterization_survey' |
    'course_type'

export type TypeCallbackFunctionEditor = (jsonObject: any, tab?: ITabEditorAcademicComponentState | ISettingsTabsEditorAcademicComponentState)=>void
export type TypeStreamCallbackFunctionEditor = (jsonObject: any)=>void

/**
 * @INFO Interfaces para TABS
 */
interface ITabEditorAcademicComponent{
    type: TypeTabsEditor
    fields: IFieldTabEditor[]
    questions?: IQuestionEditor[]
    default?: boolean
    idContent?: string
    hideNewQuestions?: boolean
    showExerciseEnded?: boolean
    extraData?: any
    hideSaveButton?: boolean
    courseModes?: ICourseModeApi[]
    callback: TypeCallbackFunctionEditor
    streamCallback?: TypeStreamCallbackFunctionEditor
    onClickQuestion?: (question: IQuestionEditorState) => void
    onClickCreateQuestion?: (parent?: string, type?: TypeQuestionsCategoriesEditor)=>void
    onFinishReorder?: (questions: IQuestionEditorState[])=>void
}

export interface ITabEditorAcademicComponentState{
    type: TypeTabsEditor
    fields: IFieldTabEditorState[]
    questions: IQuestionEditorState[]
    default?: boolean
    id: string
    idContent: string
    invalid: boolean
    hideNewQuestions?: boolean
    showExerciseEnded?: boolean
    groupsField: IGroupFieldsTabEditor[]
    extraData: any
    hideSaveButton: boolean
    courseModes?: ICourseModeApi[]
    callback: TypeCallbackFunctionEditor
    streamCallback?: TypeStreamCallbackFunctionEditor
    onClickQuestion?: (question: IQuestionEditorState) => void
    onClickCreateQuestion?: (parent?: string, type?: TypeQuestionsCategoriesEditor)=>void
    onFinishReorder?: (questions: IQuestionEditorState[])=>void
}

/**
 * @INFO Interfaces para Fields
 */
export interface IFieldTabEditor{
    type: TypeFieldsTabsEditor
    value?: string | boolean | File | IAvailabilityRange | IGameConfigEditor | number | {label: string, value: string}[] | string[]
    keyApi?: string
    required?: boolean
    options?: string[] | {label: string, value: string}[]
}

export interface IFieldTabEditorState{
    type: TypeFieldsTabsEditor
    value: string | boolean | File | IAvailabilityRange | IGameConfigEditor | number | {label: string, value: string}[] | string[]
    keyApi: string
    required: boolean
    options: string[] | {label: string, value: string}[]
    id: string
    urlLocal?: string
    invalid: boolean
    idx: number
}

export interface IGroupFieldsTabEditor{
  type: TypeGroupsTabEditor
  id: string
  state: boolean
  open: boolean
}

export interface ICourseModeApi{
  description: string
  name: string
  _id: string
}

/**
 * @INFO Interfaces para preguntas
 */
export type TypeQuestionsCategoriesEditor = 'select-range' | 'container' | 'multiple-choice-unique-answer' | 'multiple-choice-multiple-answer' | 'open-answer'
export type TypeConfigQuestions = 'ordered' | 'random'

export interface IQuestionEditorApi{
    question_category: {
        description: string
        name: TypeQuestionsCategoriesEditor
        _id: string
        config: IPossibleConfigQuestion
    }
    alliance_id: string
    config: IConfigQuestion
    content: string
    owner?: string
    created_at: Date
    deleted: boolean
    updated_at: Date
    value: number
    parent?: string
    _id: string
    answers: IAnswerEditor[]
}
export interface IQuestionEditor{
    childs?: IQuestionEditorState[]
    question: IQuestionEditorApi,
    position: number
    value: number
    _id?: string
}

export interface IQuestionEditorState extends IQuestionEditor{
    id: string
    selected: boolean
}

export interface IFillInSpacesItemEditor{
    slug: string
    label: string
    value: number
    is_trick?: boolean
}

export interface IAnswerEditor{
    unique: string
    content: string
    feedback?: string
    value: number
    is_correct: boolean
    _id: string
    config? : {
        fill_in_spaces?: IFillInSpacesItemEditor[]
        relate_item? : {
            slug: string
            type: 'question' | 'relation'
            connection?: string[]
        }
        event_type?: string
        terms_and_conditions?: string
        is_required?: boolean
    }
}

/**
 * @INFO Interfaces varias
 */
export interface IReturnTabExistEditor{
    exist: boolean
    tab?: ITabEditorAcademicComponent
}

export interface IReturnFieldExistEditor{
    exist: boolean
    field?: IFieldTabEditor
}

export interface IAvailabilityRange{
    start: Date
    end: Date
}

export interface IGameConfigEditor{
    algorithm: {
        number_of_items: number,
        theoretical_probability: number,
    }
}

/**
 * @INFO Interfaces de configuración general
 */
export interface ISettingsTabsEditorAcademicComponent{
    tabs: ITabEditorAcademicComponent[]
}

export interface ISettingsTabsEditorAcademicComponentState{
    tabs: ITabEditorAcademicComponentState[]
}

/**
 * @INFO Obtener un tab de la configuración
 * @param tab
 */
export const getTabExist = (settings: ISettingsTabsEditorAcademicComponent ,tab: TypeTabsEditor): IReturnTabExistEditor => {
  const response: IReturnTabExistEditor = {
      exist: false,
      tab: undefined
  }
  const idx = settings.tabs.findIndex(item => item.type === tab)
  if(idx < 0) return response
  response.exist = true
  response.tab = settings.tabs[idx]
  return response
}

/**
 * @INFO Obtener un field de la configuración del tab
 * @param tab
 * @param field
 */
export const getFieldExist = (tab: ITabEditorAcademicComponent | undefined, field: TypeFieldsTabsEditor): IReturnFieldExistEditor => {
    const response: IReturnFieldExistEditor = {
        exist: false,
        field: undefined
    }
    if(!tab) return response
    const idx = tab?.fields.findIndex(item => item.type === field)
    if(idx === undefined || idx < 0) return response
    response.exist = true
    response.field = tab?.fields[idx]
    return response
}

/**
 * @INFO Obtener el icono del Tab según el tipo
 * @param type
 * @param colors
 */
export const getIconFromTypeTabEdit = (type: TypeTabsEditor, colors: IColorsTheme, handleClick?: ()=>void) => {
    switch(type){
        case 'edit':
            return(
                <MdModeEdit onClick={handleClick} className='icon-tab'/>
            )
        case 'new':
            return(
                <IconComponent onClick={handleClick} svg='BixAddToQueue' class_name='icon-tab' color='#FFFFFF'/>
            )
        case 'advanced':
            return(
                // Cambiar por el verdadero
                <MdSelectAll
                  onClick={handleClick}
                  className='icon-tab'
                  style={{
                    width: '1.6rem',
                    fontSize: '1.6rem',
                  }}
                />
            )
        case 'general':
            return(
                <FiSettings onClick={handleClick} className='icon-tab'/>
            )
        case 'tools':
            return(
                <BsTools onClick={handleClick} className='icon-tab' />
            )
        case 'questions':
            return(
                <BsQuestionSquareFill onClick={handleClick} className='icon-tab' />
            )
        default:
            return(
                <FiSettings onClick={handleClick} className='icon-tab'/>
            )
    }
}

/**
 * @INFO Hacer scroll a un elemento
 * @param id
 */
export const scrollToPositionEditor = (id: string) => {
    setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 50)
}


/**
 * @INFO Filtrar campo por tipo
 * @param list
 * @param query
 * @returns
 */
export const searchFieldFromListEditor = (list: IFieldTabEditorState[], query: TypeFieldsTabsEditor) => {
  let response: {field: IFieldTabEditorState, idx: number} | undefined = undefined
  const idx = list.findIndex(item => item.type === query)
  if(idx >= 0){
    response = {
      field: list[idx],
      idx: idx
    }
  }
  return response
}


export type TypeGroupsTabEditor = 'learning' | 'resources' | 'statistics' | 'game' | 'rest' | 'exercise_ended' | 'community' | 'course_setting' | 'show_results' | 'virtual_tutoring'

/**
 * @INFO Filtrar campos según el grupo al que pertenezca
 * @param list
 * @param group
 * @returns
 */
export const filterFieldsByModuleEditor = (list: IFieldTabEditorState[], group: TypeGroupsTabEditor) => {
  let response: IFieldTabEditorState[] = []
  // Si el grupo es rest filtro los campos que no pertenecen a ningún grupo
  if(group === 'rest'){
    const groups: TypeGroupsTabEditor[] = ['game', 'learning', 'resources', 'statistics', 'community', 'course_setting', 'virtual_tutoring']
    const totalUsedFields = groups.reduce((acum: TypeFieldsTabsEditor[], item ) => {
      acum = [...acum, ...getQueriesFromGroup(item)]
      return acum
    }, [])
    response = list.reduce((acum: IFieldTabEditorState[], item) => {
      const idx = totalUsedFields.findIndex(item2 => item2 === item.type)
      if(idx < 0){
        acum.push(item)
      }
      return acum
    },[])
    return response
  }
  // Filtro los campos según el grupo
  let vectorQuery: TypeFieldsTabsEditor[] = getQueriesFromGroup(group)
  response = list.reduce((acum: IFieldTabEditorState[], item) => {
    const idx = vectorQuery.findIndex(item2 => item2 === item.type)
    if(idx >= 0){
      acum.push(item)
    }
    return acum
  },[])
  return response
}

/**
 * @INFO Obtener la lista de campos a buscar por cada grupo
 * @param group
 * @returns
 */
const getQueriesFromGroup = (group: TypeGroupsTabEditor) => {
  let response: TypeFieldsTabsEditor[] = []
  switch(group){
    case 'game':
      response = [
        'game',
        'game_statistics_module'
      ]
      break;
    case 'learning':
      response = [
        'learning_path_module'
      ]
      break;
    case 'resources':
      response = [
        'like_module',
        'comments_module',
        'complementary_resources_module'
      ]
      break;
    case 'statistics':
      response = [
        'statistics_card_iga_module',
        'statistics_card_lessons_completed_module',
        'statistics_card_progress_module',
        'statistics_card_time_module',
        'generates_statistics'
      ]
      break;
    case 'community':
      response = [
        'channels_module',
        'my_book_module',
        'share_module',
        'save_module'
      ]
      break;
    case 'course_setting':
      response = [
        'learning_way_module',
        'lessons_module',
        'exercise_module',
        'tutoring_module',
        'homework_module'
      ]
      break;
    // case 'virtual_tutoring':
    //   response = [
    //     'virtual_tutoring_external_link',
    //     'virtual_tutoring_record_link',
    //     'virtual_tutoring_access_password',
    //   ]
    //   break;
    default:
      break;
  }
  return response
}

/**
 * @INFO Obtener el tipo de dato de un campo
 * @param query   Tipo de campo a verificar
 */
type TypeReturnDataTypeFieldEditor = 'boolean' | 'text' | 'date' | 'custom' | 'file' | 'number'
export const getDataTypeFieldEditor = (query: TypeFieldsTabsEditor): TypeReturnDataTypeFieldEditor => {
  let response: TypeReturnDataTypeFieldEditor = 'custom'
  switch(query){
    case 'active':
    // case 'show_results':
    case 'continue_exercise':
    case 'generates_statistics':
    case 'complementary_resources_module':
    case 'comments_module':
    case 'like_module':
    case 'help_module':
    case 'save_module':
    case 'share_module':
    case 'related_lessons_module':
    case 'learning_way_module':
    case 'lessons_module':
    case 'exercise_module':
    case 'tutoring_module':
    case 'homework_module':
    case 'next_watching_module':
    case 'channels_module':
    case 'learning_path_module':
    case 'my_book_module':
    case 'game_statistics_module':
    case 'statistics_card_iga_module':
    case 'statistics_card_lessons_completed_module':
    case 'statistics_card_time_module':
    case 'statistics_card_progress_module':
    case 'skip_interaction':
    case 'is_characterization_survey':
      response = 'boolean'
      break;
    case 'description':
    case 'title':
    case 'virtual_tutoring_external_link':
    case 'virtual_tutoring_access_password':
    case 'virtual_tutoring_record_link':
      response = 'text'
      break;
    case 'number_questions_section':
    case 'value_component':
      response = 'number'
      break;
    case 'background':
    case 'icon':
      response = 'file'
      break;
    default:
      break;
  }
  return response
}
